<template>
  <div class="identity">
    <BaseHeaderBar title="Informasi Identitas" :showCustomerService="false" :showBackButton="true" />
    <div class="content">
      <div class="uploade">
        <van-uploader class="uploader" preview-size="0" :preview-image="false" capture="camera"
          :after-read="afterKtpRead">
          <van-icon v-show="ktpImg" class="close" name="cross" color="#000" size="24" @click.stop="deleteKtp" />
          <img v-if="ktpImg" class="ktpImg" :src="ktpImg" />
          <img v-else class="ktpImg" src="@/assets/img/identity.png" />

          <img class="identity-camera" src="@/assets/img/identity-camera.png" />
        </van-uploader>
        <div class="label">
          <p>KTP</p>
        </div>

        <van-overlay :show="ktpLoadingInfo.show" @click="ktpLoadingInfo.show = false"
          :custom-style="{ position: 'absolute' }">
          <van-loading color="#2952E5" vertical>{{
            ktpLoadingInfo.text
            }}</van-loading>
        </van-overlay>
      </div>
      <div class="uploade">
        <div class="uploader" @click="afterUserRead">
          <img v-if="userImg" class="userImg" :src="userImg" />
          <img v-else class="userImg" src="@/assets/img/recognition.png" />
          <img class="identity-camera" src="@/assets/img/identity-camera.png" />
          <van-icon v-show="userImg" class="close" name="cross" color="#000" size="24" @click.stop="deleteUser" />
        </div>
        <div class="label">
          <p>Fitur Pengenalan Wajah</p>
        </div>
        <van-overlay :show="userLoadingInfo.show" @click="ktpLoadingInfo.show = false"
          :custom-style="{ position: 'absolute' }">
          <van-loading color="#2952E5" vertical>{{
            userLoadingInfo.text
            }}</van-loading>
        </van-overlay>
      </div>
    </div>
    <button type="button" class="confirm-btn" @click="onSubmit">Kirim</button>
    <van-overlay :show="onSubmitShow">
      <van-loading color="#2952E5" vertical></van-loading>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import { Uploader, Toast, Loading, Overlay, Image as VanImage, Icon } from 'vant'
import axios from 'axios'
import Compressor from 'compressorjs'
import request from '@/utils/request'
import EXIF from 'exif-js'
import { getDurationSeconds } from '@/utils/formTracking'
Vue.use(Uploader)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Overlay)
Vue.use(VanImage)
Vue.use(Icon)
function randomString (len = 32) {
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

export default {
  name: 'Identity',
  data () {
    return {
      imgSrc: '',
      ktpImg: '',
      ktpLoadingInfo: {
        show: false,
        text: 'Proses Unggah'
      },
      userImg: '',
      userLoadingInfo: {
        show: false,
        text: 'Proses Unggah'
      },
      onSubmitShow: false,
      KtpImgSource: null,
      userImgSource: null,
      uploadTracking: this.createUploadTracking(),
      shouldResetTracking: false
    }
  },
  created () {
    this.getIdentify()
    this.uploadPromise = this.getUploadParams()
  },
  methods: {
    createUploadTracking () {
      return {
        pageEnterTime: Date.now(),
        ktp: {
          startedAt: 0,
          duration: 0,
          num: 0
        },
        selfie: {
          startedAt: 0,
          duration: 0,
          num: 0
        }
      }
    },
    resetUploadTracking () {
      this.uploadTracking = this.createUploadTracking()
    },
    startUploadTracking (type) {
      const tracking = this.uploadTracking[type]
      if (!tracking) return
      tracking.startedAt = Date.now()
    },
    finishUploadTracking (type) {
      const tracking = this.uploadTracking[type]
      if (!tracking) return
      const startedAt = tracking.startedAt || Date.now()
      tracking.duration += getDurationSeconds(startedAt)
      tracking.num += 1
      tracking.startedAt = 0
    },
    cancelUploadTracking (type) {
      const tracking = this.uploadTracking[type]
      if (!tracking) return
      tracking.startedAt = 0
    },
    getUploadTrackingData () {
      return {
        ktp_duration: this.uploadTracking.ktp.duration,
        ktp_num: this.uploadTracking.ktp.num,
        selfie_duration: this.uploadTracking.selfie.duration,
        selfie_num: this.uploadTracking.selfie.num,
        pagestay_duration: getDurationSeconds(this.uploadTracking.pageEnterTime)
      }
    },
    getIdentify () {
      request.post('iddrentityInfoPage')
        .then(res => {
          this.userImg = res.usdrerLiving_imgurl
        })
    },
    isSupportUserMedia () {
      return navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia
    },
    getUploadParams () {
      return request.post('updrloadImgToken')
    },
    uploadImg (file) {
      return new Promise((resolve, reject) => {
        this.uploadPromise.then(res => {
          const key = 'web/' + Date.now() + randomString(10) + '-' + file.name
          const formData = new FormData()
          formData.append('OSSAccessKeyId', 'LTAI5tD9wrLfvn8sEpRLfpbw')
          formData.append('key', key)
          formData.append('policy', res.podrlicy)
          formData.append('signature', res.sidrgnature)
          formData.append('file', file)
          formData.append('success_action_status', 200)
          axios.post('https://inphotos.oss-ap-southeast-1.aliyuncs.com', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(() => resolve(`https://inphotos.oss-ap-southeast-1.aliyuncs.com/${key}`))
            .catch(error => {
              Toast('Unggal Gagal')
              reject(error)
            })
        }).catch(error => {
          Toast('Unggal Gagal')
          reject(error)
        })
      })
    },
    afterKtpRead (file) {
      this.startUploadTracking('ktp')
      this.ktpLoadingInfo.show = true
      this.compressImage(file.file, result => {
        this.uploadImg(result).then(async res => {
          this.ktpImg = res
          this.finishUploadTracking('ktp')
          const isFromCamera = await this.isImageFromCamera(file.file)
          this.KtpImgSource = isFromCamera ? 1 : 2
        }).catch(() => {
          this.cancelUploadTracking('ktp')
        }).finally(() => {
          this.ktpLoadingInfo.show = false
        })
      })
    },
    compressImage (file, success) {
      let quality = 1
      const size = file.size
      const baseQuality = 1024 * 1024
      if (size < baseQuality) { // 小于1M
        quality = 0.8
      } else if (size < 5 * baseQuality) { // 小于5M
        quality = 0.4
      } else if (size < 10 * baseQuality) { // 小于10M
        quality = 0.1
      } else { // 大于10M
        quality = 0
      }
      console.log('size', size, quality)
      new Compressor(file, {
        quality,
        success
      })
    },
    deleteKtp () {
      this.ktpImg = ''
    },
    deleteUser () {
      this.userImg = ''
    },
    afterUserRead () {
      if (!this.ktpImg) {
        Toast('Silakan foto KTP')
        return false
      }
      if (this.userImg) {
        return
      }
      this.startUploadTracking('selfie')
      this.$router.push({
        path: '/userRead'
      })
    },
    validate () {
      if (!this.ktpImg) {
        Toast('Silakan foto KTP')
        return false
      }
      if (!this.userImg) {
        Toast('Silakan foto selfie')
        return false
      }
      return true
    },
    isImageFromCamera (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (event) => {
          const img = new Image()
          img.onload = () => {
            EXIF.getData(img, () => {
              const orientation = EXIF.getTag(img, 'Orientation')
              resolve(orientation !== undefined) // EXIF的Orientation标签存在，则可能是相机拍摄
            })
          }
          img.src = event.target.result
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.flag = true
      this.onSubmitShow = true
      const trackingData = this.getUploadTrackingData()
      const postData = {
        phdrotoList: JSON.stringify([{
          phdrotoUrl: this.ktpImg,
          phdrotoType: '1',
          uploadType: navigator.platform,
          imgSource: this.KtpImgSource,
          uuid: sessionStorage.getItem('ixabisoelinye')
        }, {
          phdrotoUrl: this.userImg,
          phdrotoType: '2',
          uploadType: navigator.platform,
          imgSource: this.userImgSource,
          uuid: sessionStorage.getItem('ixabisoelinye')
        }])
      }
      request.post('iddrentityInfosubmit', postData)
        .then(() => {
          return request.post('identityInfoTracking', trackingData).catch(() => false)
        })
        .then(() => {
          Toast('Pembaruan infomasi identitas berhasil')
          this.$router.back()
        })
        .catch(res => {
          if (res && res.code === 502) {
            this.deleteKtp()
          }
        })
        .finally(() => {
          this.flag = false
          this.onSubmitShow = false
        })
    }
  },
  beforeRouteEnter (to, from, next) {
    const { userReadUrl, isFromCamera } = to.query
    if (userReadUrl) {
      next(vm => {
        // 在这里，`vm` 是组件的实例，你可以访问它的数据和方法
        vm.userImg = userReadUrl
        vm.userImgSource = isFromCamera
        vm.finishUploadTracking('selfie')
      })
      return
    }
    next()
  },
  activated () {
    if (this.shouldResetTracking) {
      this.resetUploadTracking()
      this.shouldResetTracking = false
    }
  },
  beforeRouteLeave (to, from, next) {
    this.shouldResetTracking = to.path !== '/userRead'
    next()
  }
}
</script>

<style scoped lang="less">
.uploade {
  height: 400px;
  margin: 0 auto;
  margin-bottom: 130px;

  .uploader {
    position: relative;
    // padding: 0;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;

    .userImg,
    .ktpImg {
      width: 680px;
      height: 450px;
      margin-bottom: 8px;
    }
  }
}

.identity {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: @body-bg-color;
}

.content {
  margin-top: 40px;
  padding: 0 40px;

  &>div {
    .label {
      display: flex;
      justify-content: center;
      align-items: center;
      // margin-top: -36px;
      margin-left: 40px;
    }

    p {
      font-weight: 500;
      font-size: 34px;
      color: #000000;
      text-align: center;
    }

    .identity-camera {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 160px;
      height: 150px;
      z-index: 999;
      pointer-events: none;
    }

    /deep/ .van-loading {
      position: absolute;
    }
  }

  .ktp-img,
  .user-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9;
}

.confirm-btn {
  .submit-btn;
  width: 704px;
  margin-top: 48px;
}
</style>
